<template>
    <div ref="list" class="small-4 loader loader-white" id="js-observer-result">
        <ul v-if="result.length > 0" class="item-list column small-4 small-up-2 large-up-4">
            <li class="item is-relative" v-for="item in result">
                <ItemCard :item="item" :user-id="userId"/>
            </li>
        </ul>
        <!-- <p v-else class="column">Aucun résultat ne correspond à votre recherche.</p> -->
    </div>
</template>

<script>
import {hideLoader, showLoader} from '../loader';
import ItemCard from '../item/ItemCard.vue';

export default {
    components: {
        ItemCard,
    },
    props: {
        initResult: {
            type: Array,
            default: () => [],
        },
        userId: String,
    },
    data() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});
        let impressions = [];
        this.initResult.forEach(element => {
            impressions.push(element.gtm ? element.gtm : []);
        });
        window.dataLayer.push({
            'event': 'gtm.load',
            'ecommerce': {
                'currencyCode': 'EUR',
                'impressions': impressions,
            },
        });
        return {
            result: this.initResult,
        };
    },
    methods: {
        showLoader() {
            showLoader(this.$refs['list']);
        },
        updateResult(result) {
            this.result = result;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ecommerce: null});
            let impressions = [];
            this.result.forEach(element => {
                impressions.push(element.gtm ? element.gtm : []);
            });
            window.dataLayer.push({
                'event': 'gtm.load',
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'impressions': impressions,
                },
            });
            hideLoader(this.$refs['list']);
        },
        concatResult(result) {
            this.result = this.result.concat(result);
            hideLoader(this.$refs['list']);
        },
    },
};
</script>
